import { all, call, delay, put, race } from 'redux-saga/effects';
import { chatImagesClearPending } from 'features/chat/chatSlice';
import { chatImageUploadFailed } from 'features/chat/actions';
import { CHAT_IMAGE_UPLOAD_TIMEOUT_MS } from 'features/chat/constants';
import { ChatImageUploadPreparedItem, PendingChatImage } from 'features/chat/types';
import { chatImageUploadManager } from 'utils/chat-image-upload/ChatImageUploadManager';

export interface UploadChatImagesArgs {
  messageId: string;
  pendingImages: PendingChatImage[];
  preparedImages: ChatImageUploadPreparedItem[];
}

export function* uploadChatImagesSaga(args: UploadChatImagesArgs) {
  const { messageId, pendingImages, preparedImages } = args;

  // Blob preview URLs are kept alive here — the optimistic chat message owns
  // them now and they are revoked once the real chatMessageSent arrives (or
  // when the upload fails and the optimistic message is removed).
  yield put(chatImagesClearPending());

  const { timedOut } = yield race({
    uploads: all(
      pendingImages.map((pending, idx) =>
        call(
          [chatImageUploadManager, chatImageUploadManager.upload],
          messageId,
          pending,
          preparedImages[idx]
        )
      )
    ),
    timedOut: delay(CHAT_IMAGE_UPLOAD_TIMEOUT_MS),
  });

  // On timeout, reuse the failure path: it removes the optimistic message,
  // revokes its blob URLs and aborts the in-flight uploads for this message.
  if (timedOut) {
    yield put(chatImageUploadFailed({ messageId }));
  }
}
